import { standardApi } from '@/api';
import { stringify } from 'qs';
import dayjs from 'dayjs';
import { getCachedDesignEditor } from './design';

const fetchProductListByCategory = async (
  id: string,
  by: string,
  direction: string,
  pageSize: number
) => {
  const clientId = await new Promise<string>((resolve) => {
    getCachedDesignEditor(({ clientId }) => {
      resolve(clientId);
    });
  });

  const { data } = await standardApi.get(`/products/search${stringify({
    categoryNos: id !== 'all' ? id : null,
    fromDB: true,
    hasTotalCount: true,
    order: {
      by,
      direction,
    },
    pageSize,
  }, {
    addQueryPrefix: true,
    allowDots: true,
  })}`, {
    headers: {
      clientId,
    },
  });

  return data.items;
};

const fetchProductListBySection = async (
  id: string,
  by: string,
  direction: string,
  pageSize: number
) => {
  const clientId = await new Promise<string>((resolve) => {
    getCachedDesignEditor(({ clientId }) => {
      resolve(clientId);
    });
  });

  const { data } = await standardApi.get(`/display/sections/${id}${stringify({
    by,
    direction,
    hasTotalCount: true,
    pageSize,
  }, {
    addQueryPrefix: true,
    allowDots: true,
  })}`, {
    headers: {
      clientId,
      Version: '1.1',
    },
  });

  return data.products.slice(0, pageSize);
};

const parseProduct = ({
  additionDiscountAmt,
  additionDiscountUnitType,
  contentsIfPausing,
  imageUrls,
  immediateDiscountAmt,
  productName,
  productSalePeriodType,
  salePeriodType,
  salePrice,
  saleStartYmdt,
  saleStatusType,
  saleEndYmdt,
  stockCnt,
}: any) => {
  const resolvedSalePeriodType = ['REGULAR', 'PERIOD'].includes(salePeriodType) || productSalePeriodType === 'REGULAR' ?
    salePeriodType :
    'PERIOD';

  return {
    imageUrl: imageUrls[0],
    productName,
    discount: (immediateDiscountAmt + additionDiscountAmt) > 0,
    originalPrice: salePrice + additionDiscountUnitType,
    finalPrice: (salePrice - immediateDiscountAmt - additionDiscountAmt) + additionDiscountUnitType,
    saleStatusType,
    availabilityDate: `${dayjs(saleStartYmdt).format('yy.MM.dd')} ~ ${dayjs(saleEndYmdt).format('yy.MM.dd')}`,
    salePeriodType: resolvedSalePeriodType,
    soonSoldOut: stockCnt > 0 && stockCnt < 5,
    soldOut: stockCnt <= 0,
    contentsIfPausing,
  };
};

export const fetchProductList = (
  {
    count,
    id,
    sortBy,
    type,
  }: {
    type: string;
    id: string;
    count: number;
    sortBy: string;
  },
  cb: (res: {
    imageUrl: string;
    productName: string;
    soonSoldOut: boolean;
    discount: boolean;
    originalPrice: string;
    finalPrice: string;
    soldOut: boolean;
    saleStatusType: string;
    contentsIfPausing?: string;
    availabilityDate: string;
    salePeriodType: string;
  }[]) => void
) => {
  const by = sortBy === 'new' ?
    'SALE_YMD' :
      sortBy === 'admin' ?
      'ADMIN_SETTING' :
        sortBy === 'recent' ?
          'RECENT_PRODUCT' :
          'POPULAR';
  const direction = by === 'ADMIN_SETTING' ? 'ASC' : 'DESC';

  (type === 'section' ? fetchProductListBySection : fetchProductListByCategory)(id, by, direction, count)
    .then((res) => {
      const result = res.map((product) => parseProduct(product));

      cb(result);
    });
};
